import React, { FC, useCallback, useEffect } from 'react';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { Box, Button, EmptyState } from '@wix/design-system';
import { useBiSessionContext } from '@components/Contexts/BiSessionContext';
import { useBi } from '@components/Hooks/useBi';
import { exploreResultsPageGenericClick } from '@wix/bi-logger-marketplace/v2';
import { marketplace404PagePageLoadedSrc80Evid338 } from '@wix/bi-logger-partners-data-marketplace/v2';
import Header from '@components/Header';
import { explorePath } from '@components/Hooks/useRouter';

interface Props {
  origin?: string;
  entry?: string;
}

const ExploreNotFound: FC<Props> = ({ origin, entry }) => {
  const { t } = useTranslation();
  const logger = useBi();
  const { sessionId } = useBiSessionContext();

  useEffect(() => {
    logger.report(
      marketplace404PagePageLoadedSrc80Evid338({
        pageUrl: window.location.href || '',
      }),
    );
  }, []);

  const headerOnClick = () => {
    logger.report(
      exploreResultsPageGenericClick({
        clickType: 'marketplace top button',
        sessionId,
        origin: origin || '',
        entry: entry || '',
        exploreVersion: 'V2',
        data: '',
      }),
    );
  };

  const onPageNotFoundCtaClicked = useCallback(() => {
    logger.report(
      exploreResultsPageGenericClick({
        clickType: 'Go to Wix Marketplace',
        sessionId,
        origin: origin || '',
        entry: entry || '',
        exploreVersion: 'V2',
        data: '',
      }),
    );
  }, [logger, sessionId, origin, entry]);

  return (
    <Box direction="vertical" minHeight="100vh" backgroundColor="#F4F4F4">
      <Header
        onClick={headerOnClick}
        sessionId={sessionId}
        pageName="explore"
      />
      <Box align="center" verticalAlign="middle" flexGrow={1}>
        <EmptyState
          skin="page-no-border"
          title={t('explore.page-not-found.title')}
          subtitle={t('explore.page-not-found.subtitle')}
          dataHook="explore-not-found-state"
        >
          <Box marginTop="SP3">
            <Button
              skin="dark"
              as="a"
              href={explorePath}
              onClick={onPageNotFoundCtaClicked}
              dataHook="explore-not-found-cta"
            >
              {t('explore.page-not-found.cta')}
            </Button>
          </Box>
        </EmptyState>
      </Box>
    </Box>
  );
};

export default ExploreNotFound;
